// Validator
import { isEmail } from "validator";

// eslint-disable-next-line import/prefer-default-export
export const isValidPhone = (number) => /^\+[1-9]\d{0,2}\s(\d|\s|\(|\)){5,}$/.test(number);
export const isValidNumber = (number) => /[0-9]/g.test(number);
export const isValidPhoneOrEmail = (value) =>
  /^\+[1-9]\d{0,2}\s(\d|\s|\(|\)){5,}$/.test(value) || isEmail(value);
